import { ActivityDataTargetSchema } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

import { z } from 'zod'

export const ProjectInProductionActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'project_in_production',
    z.object({
      project: ActivityDataTargetSchema,
    })
  )
